// Przycisk kontaktu
// @ts-nocheck

import React, {useState} from "react";
import Popover from '@mui/material/Popover';
import classnames from 'classnames';

import styles from 'theme/components/containers/ContactButton/ContactButton.module.scss';
import { ReactComponent as HeadsetIcon } from 'assets/icons/headset.svg';

import { Trans, useTranslation } from 'react-i18next';
import { useRWD } from "hooks";
import { useGetUsersTrader } from 'api';
import { Modal } from 'components/controls';

const ContactButton = () => {
  const { t } = useTranslation();
  const { isMobile } = useRWD();

  // pobranie opiekuna
  const { data: salesmanData } = useGetUsersTrader();

  // czy jest ustawiony element HTML popovera (użyte przy pokazywaniu modala)
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLDivElement | null>(null);
  
  // czy jest otwarty modal (dla mobile)
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        "StylePath-Components-Containers-LoginButton"
      )}
    >
      <button
        className={styles.contactButton}
        onClick={(event) => {
          if (isMobile) {
            setIsModalOpen(true);
          } else {
            setPopoverAnchor(event.currentTarget);
          }
        }}
      >
        <HeadsetIcon />
        {t("Kontakt")}
      </button>

      <Popover
        anchorEl={popoverAnchor}
        open={!!popoverAnchor && !isMobile}
        onClose={() => setPopoverAnchor(null)}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        {!Array.isArray(salesmanData) && salesmanData && (
          <div className={styles.popoverContent}>
            <HeadsetIcon className={styles.popoverIcon} />
            <div className={styles.popoverText}>
              <span>
                {salesmanData.first_name} {salesmanData.last_name}
                <br />
                <Trans>Telefon</Trans>: <strong>{salesmanData.phone}</strong>
                <br />
                <Trans>Email</Trans>: <strong>{salesmanData.email}</strong>
              </span>
            </div>
          </div>
        )}
      </Popover>

      {isModalOpen && isMobile && (
        <Modal title={t('Kontakt')} onClose={() => setIsModalOpen(false)}>
          {!Array.isArray(salesmanData) && salesmanData && (
            <div className={styles.modalContent}>
              <HeadsetIcon className={styles.modalIcon} />
              <div className={styles.modalText}>
                <span>
                  {salesmanData.first_name} {salesmanData.last_name}
                  <br />
                  <Trans>Telefon</Trans>: <strong>{salesmanData.phone}</strong>
                  <br />
                  <Trans>Email</Trans>: <strong>{salesmanData.email}</strong>
                </span>
              </div>
            </div>
          )}
        </Modal>
      )}
    </div>
  );
};

export default ContactButton;
